var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "pick-and-claim-dialog",
        persistent: "",
        "max-width": "420px"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.dialogDetail.isDetails && _vm.dialogDetail.isCampaign
        ? _c(
            "div",
            { staticClass: "pnc-details-dialog" },
            [
              _c("h3", [
                _vm._v(_vm._s(_vm.dialogDetail.promotion.CampaignName))
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.dialogDetail.promotion.CampaignExternalDescription)
                )
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "close primary-btn",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v(_vm._s(_vm.$t("Dialog.btn.CLOSE")))]
              )
            ],
            1
          )
        : _vm.dialogDetail.isDetails && !_vm.dialogDetail.isCampaign
        ? _c(
            "div",
            { staticClass: "pnc-details-dialog" },
            [
              _c("h3", [
                _vm._v(_vm._s(_vm.dialogDetail.promotion.Description))
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.dialogDetail.promotion.Note))]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "close primary-btn",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v(_vm._s(_vm.$t("Dialog.btn.CLOSE")))]
              )
            ],
            1
          )
        : _c("div", { staticClass: "pnc-claim-dialog" }, [
            _vm.dialogDetail.promotion.IdCampaign
              ? _c("div", { staticClass: "campaign-description" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.dialogDetail.promotion.CampaignName))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.dialogDetail.promotion.CampaignExternalDescription
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "promo" },
              [_c("v-icon", [_vm._v("stars")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "promotion-name" }, [
              _vm._v(_vm._s(_vm.dialogDetail.promotion.Description))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "promotion-note" }, [
              _vm._v(_vm._s(_vm.dialogDetail.promotion.Note))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "claim-buttons" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "claim-buttons--close secondary-btn",
                    on: { click: _vm.closeDialog }
                  },
                  [_vm._v(_vm._s(_vm.$t("Dialog.btn.CLOSE")))]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "claim-buttons--claim primary-btn",
                    on: { click: _vm.claimPromotion }
                  },
                  [_vm._v(_vm._s(_vm.$t("Account.PickAndClaim.Claim")))]
                )
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-079b4e20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079b4e20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/PickAndClaimDialog.vue
// module id = null
// module chunks = 